import { SortDirectionType, SortOptionsType } from './enums';
import { PrimaryGuest } from './primary-guest.api';

interface CodeName {
  Code: string | null;
  Name: string | null;
}

export interface ReservationsSearchResponse {
  Items: HotelReservationSearchItem[];
  Page: number;
  PageSize: number;
  TotalItems: number;
  Overview: ReservationOverview;
  Metadata: unknown;
}

export interface ReservationsSearchQuery {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  reservationId?: string;
  reservationNumber?: string;
  roomNumber?: string;
  reservationIds?: number[];
  guestId?: number;
  reservationStatus?: ReservationStatus[];
  membershipId?: string;
  loyaltyTierCode?: string;
  sort: SortOptionsType;
  sortDirection: SortDirectionType;
}

export interface ReservationSearchRequest {
  HotelCode: string | null;
  Date: string | null;
  ReservationId: number | string | null;
  ReservationNumber: string | null;
  PersonId: number | string | null;
  FirstName: string | null;
  LastName: string | null;
  UnitCode: string | null;
  Email: string | null;
  Phone: string | null;
  MembershipId: string | null;
  LoyaltyTierCode: string | null;
  Statuses: ReservationStatus[];
  Insight: ReservationInsight | null;
  SortBy: ReservationSortBy | null;
  SortDirection: ReservationSortDirection | null;
  Page: number;
  PageSize: number;
  IncludeOverview: boolean;
}

export interface HotelReservationSearchItem {
  Id: number;
  HotelCode: string;
  Status: ReservationStatus;
  ArrivalDate: string;
  DepartureDate: string | null;
  PrimaryGuest: PrimaryGuest | null;
  ReservationNumber: string | null;
  NumberOfNights: number | null;
  UnitType: CodeName | null;
  UnitCode: string | null;
  HasNotes: boolean;
  RatePlans: CodeName[];
}

export interface HotelReservation extends HotelReservationSearchItem {
  NumberOfAdults?: number | null;
  NumberOfChildren?: number | null;
  NumberOfInfants?: number | null;
  NumberOfNights: number | null;
  Source?: string | null;
  AverageNightlyRate?: number | null;
  Notes?: unknown[];
  Attributes?: unknown[];
}

export interface ReservationOverview {
  [ReservationInsight.Arrivals]: number;
  [ReservationInsight.InHouse]: number;
  [ReservationInsight.Departing]: number;
  [ReservationInsight.Departed]: number;
}

export enum ReservationInsight {
  Arrivals = 'Arrivals',
  InHouse = 'InHouse',
  Departing = 'Departing',
  Departed = 'Departed',
}

export enum ReservationSortBy {
  RfmScore = 'RfmScore',
  RoomType = 'RoomType',
  LastName = 'LastName',
  LoyaltyTier = 'LoyaltyTier',
  VipTier = 'VipTier',
}

export enum ReservationSortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export enum ReservationStatus {
  InHouse = 'I',
  Reserved = 'R',
  History = 'H',
  Cancelled = 'X',
  CancelledNoShow = 'XNS',
  NoShow = 'NS',
  Unconfirmed = 'U',
}
